import { useLocation } from "react-router-dom";
import { Task } from "../../api/Tasks";
import { useUrlState } from "../../misc/urlParams";
import { usePhone } from "../../misc/usePhone";

// newTaskPath ends the path of a page with a new task open on it (see useOpenTask)
export const newTaskPath = "/new";

// pagePath is the path of the page itself, with the new task taken off it
export function pagePath(pathname: string) {
    return pathname.endsWith(newTaskPath) ? pathname.slice(0, -newTaskPath.length) : pathname;
}

// useOpenTask is the task a page has open, which the url names so a link opens the
// same thing and the back button walks out of it. An existing task is named by its
// id in the query string. A new one has no id yet: a phone names it on the path, and
// a desktop names it in the query string.
export function useOpenTask() {
    const phone = usePhone();
    const url = useUrlState();
    const loc = useLocation();
    const page = pagePath(loc.pathname);

    return {
        id: url.id("task"),
        isNew: loc.pathname !== page || url.text("task") === "new",

        open: (task: Partial<Task>) => {
            if (task.id) {
                url.set({ task: String(task.id) }, { path: page });
                return;
            }

            // a new task opens on the day it's due, which is where it's listed once saved
            const changes: Record<string, string> = task.dueDate ? { date: task.dueDate } : {};

            if (phone) url.set({ ...changes, task: "" }, { path: page + newTaskPath });
            else url.set({ ...changes, task: "new" }, { path: page });
        },

        close: () => url.set({ task: "" }, { path: page }),
    };
}
